<template>
<div>
  <el-card shadow="never">
    <bills :uid="uid"></bills>
  </el-card>
  <br/>
  <el-card shadow="never">
    <h3>充提记录</h3>
    <el-table :data="userRecords">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{scope.row.createdTime | moment}}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.txType==(1)">
              {{'充值'+scope.row.txCoin}}
            </span>
          <span v-if="scope.row.txType==(-1)">
              {{'提现'+scope.row.txCoin}}
            </span>
        </template>
      </el-table-column>
      <el-table-column label="(充值/提现)金额" prop="txAmount">
      </el-table-column>
      <el-table-column label="提现手续费" prop="txFee">
      </el-table-column>
      <el-table-column label="从" prop="txFromWallet">
      </el-table-column>
      <el-table-column label="至" prop="txToWallet">
      </el-table-column>
      <el-table-column label="hash">
        <template slot-scope="scope">
          <span v-if="scope.row.txNetworkId">
              <a :href="txMaps[scope.row.txCoin]+scope.row.txNetworkId" target="_blank" style="color:#409eff;text-decoration:underline;">{{scope.row.txNetworkId}}</a>
            </span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.txStatus == 0">已经确认</span>
          <span v-if="scope.row.txStatus == 1">已提交</span>
          <span v-if="scope.row.txStatus == 2">取消</span>
          <span v-if="scope.row.txStatus == (-1)">失败</span>
          <span v-if="scope.row.txStatus == 3">确认中</span>
          <span v-if="scope.row.txStatus == 4">已审核</span>
          <span v-if="scope.row.txStatus == 5">区块链网络已经发送，等待确认中</span>
          <span v-if="scope.row.txStatus == 6">系统异常</span>
          <span v-if="scope.row.txStatus == 7">管理员撤销</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="user-withdrawal-pager-wrap">
      <pagination :size="userDetailPagination.size" :page="userDetailPagination.page" :total="userDetailTotal" @pageChanged="handleCurrentChange">
      </pagination>
    </div>
  </el-card>
  <balance></balance>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination';
import Balance from '../balance';
import Bills from '../bills';
import { TX_MAPS } from '../../constants.js';

export default {
  name: 'records',
  props: ['uid'],
  data() {
    return {
      txMaps: {}
    };
  },
  computed: {
    ...mapState('merchantAudit', [
      'userRecords',
      'userDetailTotal',
      'userWallet',
      'userDetailPagination'
    ])
  },
  components: {
    Pagination,
    Balance,
    Bills
  },
  methods: {
    ...mapActions('merchantAudit', [
      'getUserRecords',
      'resetUserRecords',
      'getUserWallet'
    ]),
    getList(data) {
      this.getUserRecords({
        userId: this.uid,
        ...this.userDetailPagination,
        ...data
      });
    },
    handleCurrentChange(pagination) {
      this.getList(pagination);
    }
  },
  mounted() {
    this.getList();
    this.txMaps = TX_MAPS;
  },
  destroyed() {
    this.resetUserRecords();
  }
};
</script>
